import * as React from "react";
import { connect } from "react-redux";
import { DateRangePicker } from "react-date-range";
import moment from "moment";

// material ui
import { withStyles } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";

const defaultMinMaxDates = { minDate: undefined, maxDate: moment().add(1, 'day').toDate() };

const max7daysRange = 7;
const max7daysUnit = 'days';
const max7daysMessage = '7 days maximum';

const max2yearsRange = 2;
const max2yearsUnit = 'years';
const max2yearssMessage = '2 years maximum';

const styles = theme => ({
  label: {
    color: theme.palette.grey[500],
  },
  message: {
    color: theme.palette.grey[500],
    padding: theme.spacing(1)
  }
});

class CustomDateRangePicker extends React.Component {
  state = {
    selection: {
      startDate: moment().subtract(24, "h"),
      endDate: moment(),
      key: "selection"
    },
    ...defaultMinMaxDates,
    emailValue: '',
    definedRanges: [
      {
        hasCustomRendering: true,
        label: 'This week',
        range: function () {
          return {
            startDate: moment()
              .startOf("week")
              .toDate(),
            endDate: moment()
          };
        },
        isSelected() {
          return false;
        }
      },
      {
        hasCustomRendering: true,
        label: 'Past Week',
        range: function () {
          return {
            startDate: moment()
              .subtract(1, "weeks")
              .startOf("hour")
              .add(1, "hour")
              .toDate(),
            endDate: moment()
          };
        },
        isSelected() {
          return false;
        }
      }
    ]
  };

  componentDidMount = () => {
    const { dateRange: { startDate, endDate, key }, emailValue } = this.props;
    this.setState({
      selection: { startDate, endDate, key },
      emailValue
    });
  };

  componentDidUpdate = ({ emailValue: prevEmailValue }) => {
    const { emailValue } = this.props;

    if (emailValue !== prevEmailValue) {
      this.setState({
        emailValue
      });
    }
  };

  handleRangeChange = newDateRange => {
    const { startDate: start, endDate: end, key } = newDateRange.selection;
    const startDate = moment(start);
    const endDate = moment(end);

    if (start instanceof Date && end instanceof Date) {
      this.setMinMaxDates(startDate);
    } else {
      this.cleanMinMaxDates();
    }

    const updatedEndDate = startDate.unix() === endDate.unix() ?
      endDate.clone().add(24, "h").toDate() :
      endDate;

    this.setState({
      selection: {
        startDate,
        endDate: updatedEndDate,
        key
      }
    });
  };

  handleSubmit = () => {
    const { emailValue, selection: { startDate, endDate } } = this.state;
    this.props.onSubmit({ startDate, endDate, emailValue });
  };

  handleEmailChange = ({ target: { value } }) => this.setState({ emailValue: value });

  setMinMaxDates = startDate => {
    const { twoYearsMode } = this.props;

    const range = twoYearsMode ? max2yearsRange : max7daysRange;
    const unit = twoYearsMode ? max2yearsUnit : max7daysUnit;

    const maxDate = moment(startDate).add(range, unit).toDate();

    this.setState({
      minDate: moment(startDate).subtract(range, unit).toDate(),
      maxDate: moment().isBefore(maxDate) ? moment().add(1, 'day').toDate() : maxDate
    });
  };

  cleanMinMaxDates = () => this.setState(defaultMinMaxDates);

  render() {
    const { classes, twoYearsMode, actionText } = this.props;
    const { selection, minDate, maxDate, definedRanges, emailValue } = this.state;
    return (
      <React.Fragment>
        <ValidatorForm
          ref={this.form}
          onSubmit={this.handleSubmit}
          onError={errors => console.log("error on form submit", errors)}
          debounceTime={300}
        >
          <Typography variant="h6" id="modal-title">
            Select your date range
          </Typography>
          <section title="DateRangePicker - Vertical Infinite">
            <div>
              <DateRangePicker
                onChange={this.handleRangeChange}
                className="PreviewArea"
                ranges={[selection]}
                minDate={minDate}
                maxDate={maxDate}
                staticRanges={definedRanges}
              />
            </div>
            <Grid container justify="flex-end">
              {
                twoYearsMode ? (
                  <Grid item>

                    <label htmlFor="emailId" className={classes.label}>Send export to :</label>

                    <TextValidator
                      onChange={this.handleEmailChange}
                      value={emailValue}
                      id="emailId"
                      type="email"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      margin="none"
                      validators={['required', 'isEmail']}
                      placeholder="email@malteurop.com"
                      errorMessages={['this field is required', 'email is not valid']}
                    />
                  </Grid>
                ) : null
              }
              <Grid item>
                <div className={classes.message}>({twoYearsMode ? max2yearssMessage : max7daysMessage})</div>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="default"
                  type="submit"
                >
                  {actionText}
                </Button>
              </Grid>
            </Grid>
          </section>
        </ValidatorForm>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  dateRange: state.dateRange,
  mode: state.mode
});

export default withStyles(styles)(
  connect(
    mapStateToProps
  )(CustomDateRangePicker)
);



// WEBPACK FOOTER //
// ./src/components/common/CustomDateRangePicker.js